import React from 'react';

import Header from './Header';
import Main from './Main';

function App() {
  return (
    <div className=''>
      <Header />
      <Main />
    </div>
  );
}

export default App;
